import moment from 'moment';
import Vue from 'vue';
export default {
    transformEndTime: function (timeString:any, num?:any, sysDate?:any) {
        if(timeString) {
            // timeString = timeString.replace(new RegExp(/-/gm) ,"/")
            timeString = moment(timeString)
            num ? undefined : num = 7; //7-8天显示7天后
            if (timeString) {
                var dis = timeString.valueOf() - (sysDate ? sysDate : new Date());
                var diffDay = dis / (24 * 3600 * 1000);
                if (diffDay < 0) {
                    //已过期
                    return '<div class="icon-css"><i class="icon icon-click-16 icon-css"></i> '+ Vue.$trans(`已过期`) +'</div>'
                } else if (diffDay < 1) {
                    return '<div class="icon-css"><i class="icon icon-click-16 icon-css"></i>' + this.countTime(timeString) + '</div>'
                } else if (diffDay >= 1 && diffDay <= num) {
                    return '<div class="icon-css"><i class="icon icon-click-16 icon-css"></i>' + Vue.$trans(`{0}天后到期`, Math.floor(diffDay))  + '</div>'
                } else if (diffDay > 7 && diffDay < 8) {
                    return '<div class="icon-css"><i class="icon icon-click-16 icon-css"></i>' + Vue.$trans(`{0}天后到期`, Math.floor(diffDay)) + '</div>'
                } else {
                    return '<div class="inline-div">' + moment(timeString).format('YYYY-MM-DD HH:mm:ss') + '</div>';
                }
            } else {
                return '<div class="inline-div">' + '--' + '</div>';
            }
        } else {
            return '--';
        }
    },
    countTime: function (closeTime:any) {
        if (closeTime == 0 || closeTime < 0) return;
        var endDate = new Date(closeTime);
        var leftTime = endDate.getTime() - new Date().getTime();
        var leftsecond = ~~(leftTime / 1000);
        var day1 = Math.floor(leftsecond / (60 * 60 * 24));
        var hour = Math.floor((leftsecond - day1 * 24 * 60 * 60) / 3600);
        var minute = Math.floor((leftsecond - day1 * 24 * 60 * 60 - hour * 3600) / 60);
        var second = Math.floor(leftsecond - day1 * 24 * 60 * 60 - hour * 3600 - minute * 60);
        //小时后到期
        var res = Vue.$trans(`{0}小时后到期`, hour);
        return res;
    },
    formatTimestamp: function (d:any) {
        if (d) {
            return moment(d).utc().format('YYYY-MM-DD HH:mm:ss')
        }
        return '--';
    },

    formatTimeNoUtc: function (d:any) {
        if (d) {
            return moment(d).format('YYYY-MM-DD HH:mm:ss')
        }
        return '--';
    },
    // 硬盘页到期时间的处理
    formatTimespecial: function (d:any) {
        if (d) {
            return moment(Number(d)).format('YYYY-MM-DD HH:mm:ss')
        }
        return '--';
    },
    transformEndTimeSpecial: function(d:any) {
        if (d) {
            let formatTime = moment(Number(d)).format('YYYY-MM-DD HH:mm:ss')
            if (formatTime) {
                return this.transformEndTime(formatTime)
            }
        }
        return '--';
    },
    addTime: function(timeString:any, num:any, type:any) {
        if (!type) type = 'months';
        timeString = moment(timeString).format('YYYY-MM-DD HH:mm:ss');
        return moment(timeString).add(num, type).format("YYYY-MM-DD HH:mm:ss")
    }
};
